module.exports = __webpack_public_path__ + "img/3983529.55a0f79e.png";